import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * - 上报时机
 *  1. 首次加载时 pageload
 *  2. SPA router 切换时 navigation 
 *
 * - 数据采集：
 *  1. 需要立即执行的异步任务 webVitals longtask 。 (netSpeed 后置避免影响首屏)
 *  2. 同步任务参数收集 navigationTiming / performance-resource / performance-paint
 */

import lego from "../../lego";
import { registerTriggerHandlers, getBrowserTimeOrigin, getPageUrl, getPageType, ref, waitTime } from "../utils";
import { createTask, startWebVitals, startLongTasks, startNetworkPing, startMemory, startRerenderEvent, startPerformance, startTTI_TTB, startTTFB, startLongAnimationFrame } from "./task";
var firstTask;
var activeTaskRef = ref({});
export var createInstance = function createInstance(options) {
  var startingUrl = window.location.href;
  var ctx = {
    options: options,
    state: 'pageload'
  };
  var enablePageLoad = options.enablePageLoad,
    enabledLongTask = options.enabledLongTask,
    enabledWebVitals = options.enabledWebVitals,
    enabledLocationChange = options.enabledLocationChange,
    enableInitTestLegoSend = options.enableInitTestLegoSend,
    enableNetworkPing = options.enableNetworkPing,
    enabledMemory = options.enabledMemory,
    enabledRerenderEvent = options.enabledRerenderEvent,
    enableCheckPagetypeChange = options.enableCheckPagetypeChange,
    needMergeRoute = options.needMergeRoute,
    needPathName = options.needPathName,
    enableTBT = options.enableTBT,
    enableTTFB = options.enableTTFB,
    enableLoaf = options.enableLoaf;

  // just for test
  var testLegoData = function testLegoData(pagestate) {
    var actiontype = 'PERFORMANCE-TEST';
    var pagetype = getPageType();
    var pageurl = getPageUrl();
    var backup = {
      pageurl: pageurl,
      pagestate: pagestate
    };
    lego.send({
      actiontype: actiontype,
      pagetype: pagetype,
      backup: backup
    }, function () {}, true);
  };
  if (enableInitTestLegoSend) {
    setTimeout(function () {
      return testLegoData('pageload');
    }, 100);
  }
  if (enablePageLoad) {
    ctx.state = 'pageload';
    ctx.startTimestamp = getBrowserTimeOrigin();
    ctx.timeOrigin = getBrowserTimeOrigin();
    firstTask = createTask(ctx);
    activeTaskRef.value = _objectSpread({}, firstTask);
  }
  if (enabledWebVitals) {
    // console.log('enabledWebVitals', enabledWebVitals)
    startWebVitals(firstTask);
  }
  if (enabledLongTask) {
    // console.log('enabledLongTask', enabledLongTask)
    startLongTasks(activeTaskRef);
  }
  if (enabledLongTask && enableTBT) {
    startTTI_TTB(firstTask);
  }
  if (enableTTFB) {
    startTTFB(firstTask);
  }
  if (enableNetworkPing) {
    // console.log('enableNetworkPing', enableNetworkPing)
    startNetworkPing(activeTaskRef);
  }
  if (enabledMemory) {
    // console.log('enabledMemory', enabledMemory)
    startMemory(activeTaskRef);
  }
  if (enabledRerenderEvent) {
    // console.log('enabledRerenderEvent', enabledLongTask)
    startRerenderEvent(activeTaskRef);
  }
  if (enableLoaf) {
    startLongAnimationFrame(activeTaskRef);
  }
  if (enabledLocationChange) {
    // console.log('enabledLocationChange enableCheckPagetypeChange', enabledLocationChange, enableCheckPagetypeChange)
    var lastPageType = getPageType(needMergeRoute, needPathName);
    var listenWrap = function listenWrap() {
      // console.log('registerTriggerHandlers', 'history')
      registerTriggerHandlers('history', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
          var from, to, curPage, _activeTaskRef$value, startTimestamp, timeOrigin, _activeTaskRef$value2, _startTimestamp, _timeOrigin;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                from = _ref.from, to = _ref.to;
                //
                console.log('navigation', {
                  from: from,
                  to: to
                }, startingUrl);
                if (enableInitTestLegoSend) {
                  setTimeout(function () {
                    return testLegoData('navigation');
                  }, 100);
                }
                if (!(from === undefined && startingUrl && startingUrl.indexOf(to) > -1)) {
                  _context.next = 6;
                  break;
                }
                startingUrl = undefined;
                return _context.abrupt("return");
              case 6:
                if (!(from !== to)) {
                  _context.next = 34;
                  break;
                }
                startingUrl = undefined;
                // enableCheckPagetypeChange
                if (!enableCheckPagetypeChange) {
                  _context.next = 28;
                  break;
                }
                _context.next = 11;
                return waitTime();
              case 11:
                curPage = getPageType(needMergeRoute, needPathName); // console.log('lastPageType curPage', lastPageType, curPage);
                if (!(lastPageType !== curPage)) {
                  _context.next = 26;
                  break;
                }
                // 每次更新起始时间，
                // 因为约定好 每次路由切换 需要当作一个页面 重新上报所有性能数据，另外，后端不支持分段上报
                // 采用 performance api 精度更高
                startTimestamp = (getBrowserTimeOrigin() || 0) + performance.now();
                timeOrigin = getBrowserTimeOrigin();
                if (!((_activeTaskRef$value = activeTaskRef.value) !== null && _activeTaskRef$value !== void 0 && _activeTaskRef$value.finish)) {
                  _context.next = 24;
                  break;
                }
                _context.prev = 16;
                _context.next = 19;
                return activeTaskRef.value.finish({
                  finishState: 'navigation'
                });
              case 19:
                _context.next = 24;
                break;
              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](16);
                console.log('error', _context.t0);
              case 24:
                activeTaskRef.value = createTask(_objectSpread(_objectSpread({}, ctx), {}, {
                  state: 'navigation',
                  startTimestamp: startTimestamp,
                  timeOrigin: timeOrigin
                }));
                lastPageType = curPage;
              case 26:
                _context.next = 34;
                break;
              case 28:
                // 每次更新起始时间，
                // 因为约定好 每次路由切换 需要当作一个页面 重新上报所有性能数据，另外，后端不支持分段上报
                // 采用 performance api 精度更高
                _startTimestamp = (getBrowserTimeOrigin() || 0) + performance.now();
                _timeOrigin = getBrowserTimeOrigin();
                if ((_activeTaskRef$value2 = activeTaskRef.value) !== null && _activeTaskRef$value2 !== void 0 && _activeTaskRef$value2.finish) {
                  try {
                    activeTaskRef.value.finish({
                      finishState: 'navigation'
                    });
                  } catch (error) {
                    console.log('error', error);
                  }
                }
                _context.next = 33;
                return waitTime();
              case 33:
                activeTaskRef.value = createTask(_objectSpread(_objectSpread({}, ctx), {}, {
                  state: 'navigation',
                  startTimestamp: _startTimestamp,
                  timeOrigin: _timeOrigin
                }));
              case 34:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[16, 21]]);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };
    if (document.readyState === 'complete') {
      listenWrap();
    } else {
      window.addEventListener('load', function () {
        listenWrap();
      });
    }
  }
  {
    // performanceTiming / resource 等统计
    startPerformance(activeTaskRef);
  }
  return ctx;
};
export var getActiveTask = function getActiveTask() {
  return activeTaskRef.value;
};